import React, { useEffect, useState } from 'react';
import { SimulatorRoom } from '../../Types/SimulatorRoom';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import '../../../images/xyz.jpg';
import Product from '../../Types/Product';
import clsx from 'clsx';
import LoadingSpinner from '../LoadingSpinner';

interface SimulatorCanvasProps {
  simulatorRooms: SimulatorRoom[];
  selectedRoom: SimulatorRoom;
  activeProduct?: Product;
  isFullScreen?: boolean;
  setSelectedRoom: (room: SimulatorRoom) => void;
}

const MAX_MS_BEFORE_SHOW_SPINNER = 100;

const WallPaperSimulatorCanvas = ({
  selectedRoom,
  activeProduct,
  isFullScreen = false,
}: SimulatorCanvasProps) => {
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  useEffect(() => {
    if (!activeProduct?.simulatorGeneratedImageUrl) return;

    setIsLoadingImage(true);

    const loadingTimer = setTimeout(
      () => setShowLoadingSpinner(true),
      MAX_MS_BEFORE_SHOW_SPINNER
    );

    const onLoadOrAbort = () => {
      clearTimeout(loadingTimer);
      setIsLoadingImage(false);
      setShowLoadingSpinner(false);
      image.remove();
    };

    const image = new Image();
    image.addEventListener('load', onLoadOrAbort);
    image.addEventListener('abort', onLoadOrAbort);
    image.addEventListener('error', onLoadOrAbort);
    image.src = activeProduct.simulatorGeneratedImageUrl;

    return () => {
      onLoadOrAbort();
    };
  }, [activeProduct]);

  return (
    <div
      id="simulator-canvas"
      className={clsx(
        'relative grid grid-cols-1 overflow-hidden rounded object-cover aspect-[675/900] store-screen:before:absolute store-screen:before:bottom-0 store-screen:before:left-0 store-screen:before:right-0 store-screen:before:top-0',
        isFullScreen ? 'h-auto' : 'w-full max-w-[470px]'
      )}
    >
      <div
        className="z-1 absolute bottom-0 left-0 right-0 top-0 h-full w-full"
        style={{
          backgroundImage: `url("${
            !isLoadingImage
              ? activeProduct?.simulatorGeneratedImageUrl ?? ''
              : ''
          }")`,
          backgroundSize: '100%',
          scale: `calc(100% * ${
            selectedRoom.roomZoomMultiplier > 1
              ? selectedRoom.roomZoomMultiplier
              : 1
          })`,
        }}
      ></div>
      <ResponsiveImage
        pictureProps={{
          className:
            'rounded col-start-1 row-start-1 z-10 object-cover h-full',
        }}
        imgProps={{
          className: 'w-full max-w-[unset] h-full object-cover',
        }}
        {...selectedRoom.roomImage}
      />
      {showLoadingSpinner && (
        <div className="absolute inset-0 z-20 bg-opacity-white-50">
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <LoadingSpinner className="h-12 w-12" />
          </div>
        </div>
      )}
    </div>
  );
};

export default WallPaperSimulatorCanvas;
